import { Button } from '@components/ui/button';
import { HttpStatus } from '@constants/http';
import { Pages } from '@constants/pages';
import { Home } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

function NotFound() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background text-foreground p-4">
      <h1 className="text-9xl font-bold text-primary">{HttpStatus.NotFound}</h1>
      <p className="mt-4 text-2xl text-center text-muted-foreground">{t('common.not_found')}</p>

      <Button
        onClick={() => navigate(Pages.Chat)}
        className="mt-8 px-6 py-3 bg-primary text-secondary rounded-lg hover:bg-primary/90 transition-colors"
      >
        <Home />
        {t('common.go_back_home')}
      </Button>
    </div>
  );
}

export default NotFound;
